import { styled, Tab } from "@mui/material"

const MinimalTab = styled(Tab)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  flex: "1 1 auto",
  textAlign: "center",
  maxWidth: "unset !important",
  minWidth: "unset !important",
  minHeight: "unset !important",
  fontSize: "0.75rem",
  fontWeight: "600",
  textTransform: "none",
  lineHeight: "inherit",
  padding: "4px",
  borderRadius: "0.5rem",
  color: `${theme.palette.text.primary} !important`,
  opacity: "1 !important",
  "&.Mui-selected": {
    transition: "all 500ms ease",
    color: `${theme.palette.background.paper} !important`
  },
  "& .material-icons, .material-icons-round": {
    marginBottom: "0 !important",
    marginRight: "4px"
  },

  "& svg": {
    marginBottom: "0 !important",
    marginRight: "6px"
  },

  labelIcon: {
    paddingTop: "4px"
  },
}))
export default MinimalTab
